import { Injectable } from '@angular/core';
import { Privileges, PrivilegesEntryRouteMAP, PrivilegesRouteIdMap } from 'app/constants';

import { tenantNavItems, superNavItems } from 'app/navs';

import { HelperService } from 'app/services/helper.service';

/**
 * Role Service for user role based actions
 */
@Injectable()
export class ACLService {
  // a boolean map that contains a string: boolean map
  // for all allowed privileges
  private allowedPrivileges = {};

  /**
   * Role Object Including based in role
   * - Dashboard entry point
   * - Navigation Menu
   * - Sllowed Screens
   */
  private defaultACLConfig = {
    // onboarder user group
    super: {
      entry: '/company/list',
      nav: superNavItems,
      allowedScreens: [],
    },
    onboarder: {
      entry: '/company/list',
      nav: superNavItems,
      allowedScreens: [],
    },
    engg: {
      entry: '/company/list',
      nav: superNavItems,
      allowedScreens: [],
    },
    sales: {
      entry: '/company/list',
      nav: superNavItems,
      allowedScreens: [],
    },

    // tenant user group
    admin: {
      entry: '/dashboard',
      nav: tenantNavItems,
      allowedScreens: [
        'purchase-order',
        'purchase-online-order',
        'purchase-online-order/tire-connect',
        'main-chats',
        'marketing',
        'group-step-2',
        'campaign-action',
        'campaign',
        'campaign-list',
        'followup-campaign',
        'followup-campaign-list',
        'marketing-dashboard',
        'scheduled-followup-campaign-list',
        'template-list',
        'group-list',
        'lead-source-list',
        'workboard',
        'main-customers',
        'main-catalog',
        'main-workboard',
        'main-calendar',
        'main-parts',
        'customer-list',
        'deferred-list',
        'estimate-list',
        'partstech-list',
        'unused-list',
        'service-list',
        'payment-list',
        'labor-list',
        'discount-list',
        'flat-rate-list',
        'tire-list',
        'tire-storage-list',
        'supplier-list',
        'fees-list',
        'canned-inspection-list',
        'categories-list',
        'sales-codes-list',
        'warranties-list',
        'warranty-policy-terms',
        'stock-list',
        'purchase-order-list',
        'online-order-list',
        'transfer-order-list',
        'purchase-order',
        'transfer-stock',
        'purchase-online-order',
        'purchase-online-order/tire-connect',
        'location-list',
        'inspection-list',
        'services-list',
        'parts-list',
        'review-summary',
        'review-settings',
        'sales-reports',
        'canned-service-reports',
        'canned-service-detail-reports',
        'outstand-inginvoice-reports',
        'order-ar-by-cutomer',
        'technician-attendance-log-reports',
        'technician-summary-reports',
        'technician-detail-reports',
        'technician-summary-all-service-reports',
        'technician-summary-reports-all-service-details',
        'labor-reporting-drill-down',
        'technician-activity-reports',
        'orders-reports',
        'customers-reports',
        'google-review-reports',
        'internal-survey-reports',
        'all-payments-reports',
        'inventory-activity-reports',
        'inventory-level-reports',
        'unused-inventory',
        'profitability-reports',
        'location',
        'taxes-reports',
        'taxes-drilldown-reports',
        'items-sold-report',
        'items-enhance-item-sold',
        'items-enhance-item-sold-detail',
        'fee-report',
        'fee-drill-down-report',
        'custom-reporting-reports',
        'discount-drill-down-report',
        'supplier-summary-reports',
        'supplier-detail-reports',
        'drill-down-report',
        'commission-summary-reports',
        'commission-detail-reports',
        'acc-payable-supplier-reports',
        'acc-payable-drilldown-report',

        'main-estimate',
        'main-reviews',
        'admin-qbo',
        'technician-attendance-log-details-reports',
        'customer-center',

        // Customers
        'main-customers',
        'customer-list',
        'deferred-list',
        'repair-orders',
        'payment-list',
        'partstech-list',
        'unused-list',
        'end-day-cash-drawer',
        'end-day-cash-drawer-details',
        'statement-list',

        // Catalog
        'main-catalog',
        'labor-list',
        'discount-list',
        'parts-list',
        'tire-list',
        'tire-storage-list',
        'supplier-list',
        'fees-list',
        'services-list',
        'inspection-list',
        'canned-inspection-list',
        'categories-list',
        'sales-codes-list',
        'warranties-list',
        'warranty-policy-terms',
        'items-sold-report',
        'drill-down-report',
        'flat-rate-list',

        // Inventory
        'main-inventory',
        'stock-list',
        'purchase-order-list',
        'online-order-list',
        'transfer-order-list',
        'location-list',
        'parts-return-list',
        'core-list',
        'warranties-report'
      ],
    },
    serviceWriter: {
      entry: '/workboard',
      nav: tenantNavItems,
      allowedScreens: [
        'purchase-order',
        'purchase-online-order',
        'purchase-online-order/tire-connect',
        'main-chats',
        'marketing',
        'group-step-2',
        'campaign',
        'campaign-action',
        'campaign-list',
        'followup-campaign',
        'followup-campaign-list',
        'marketing-dashboard',
        'scheduled-followup-campaign-list',
        'template-list',
        'group-list',
        'lead-source-list',
        'workboard',
        'main-customers',
        'main-catalog',
        'main-workboard',
        'main-calendar',
        'main-parts',
        'customer-list',
        'estimate-list',
        'partstech-list',
        'unused-list',
        'service-list',
        'payment-list',
        'review-summary',
        'review-settings',
        'services-list',
        'deferred-list',
        'parts-list',
        'labor-list',
        'discount-list',
        'flat-rate-list',
        'tire-list',
        'tire-storage-list',
        'supplier-list',
        'fees-list',
        'canned-inspection-list',
        'categories-list',
        'sales-codes-list',
        'warranties-list',
        'warranty-policy-terms',
        'stock-list',
        'location',
        'purchase-order-list',
        'online-order-list',
        'transfer-order-list',
        'transfer-stock',
        'purchase-order',
        'purchase-online-order',
        'purchase-online-order/tire-connect',
        'location-list',
        'inspection-list',
        'profitability-reports',
        'main-estimate',
        'main-reviews',
        'sales-reports',
        'canned-service-reports',
        'canned-service-detail-reports',
        'labor-reporting-drill-down',
        'outstand-inginvoice-reports',
        'order-ar-by-cutomer',
        'technician-attendance-log-reports',
        'technician-summary-reports',
        'technician-detail-reports',
        'technician-summary-all-service-reports',
        'technician-summary-reports-all-service-details',
        'technician-activity-reports',
        'orders-reports',
        'customers-reports',
        'google-review-reports',
        'internal-survey-reports',
        'all-payments-reports',
        'inventory-activity-reports',
        'inventory-level-reports',
        'unused-inventory',
        'items-sold-report',
        'items-enhance-item-sold',
        'items-enhance-item-sold-detail',
        'supplier-summary-reports',
        'supplier-detail-reports',
        'drill-down-report',
        'fee-report',
        'fee-drill-down-report',
        'custom-reporting-reports',
        'taxes-reports',
        'taxes-drilldown-reports',
        'commission-summary-reports',
        'commission-detail-reports',
        'acc-payable-supplier-reports',
        'acc-payable-drilldown-report',
        // 'main-settings',
        'technician-attendance-log-details-reports',
        'customer-center',

        // Customers
        'main-customers',
        'customer-list',
        'deferred-list',
        'repair-orders',
        'payment-list',
        'partstech-list',
        'unused-list',
        'end-day-cash-drawer',
        'end-day-cash-drawer-details',
        'statement-list',

        // Catalog
        'main-catalog',
        'labor-list',
        'discount-list',
        'parts-list',
        'tire-list',
        'tire-storage-list',
        'supplier-list',
        'fees-list',
        'services-list',
        'inspection-list',
        'canned-inspection-list',
        'categories-list',
        'sales-codes-list',
        'warranties-list',
        'warranty-policy-terms',
        'items-sold-report',
        'drill-down-report',
        'flat-rate-list',

        // Inventory
        'main-inventory',
        'stock-list',
        'purchase-order-list',
        'online-order-list',
        'transfer-order-list',
        'location-list',
        'parts-return-list',
        'core-list',
        'warranties-report'
      ],
    },

    // technician user group
    tech: {
      entry: 'tech/orders',
      nav: tenantNavItems,
      allowedScreens: ['tech'],
    },
  };

  private currentACLConfig: any = this.helperService.deepCopy(this.defaultACLConfig);

  constructor(private helperService: HelperService) {}

  /**
   * Construct a flat allowed privilege map
   */
  private constructAllowedPrivilegeMap(): void {
    // reset current privilege map
    this.allowedPrivileges = {};

    // reconstruct default privilege map
    Object.keys(Privileges).forEach((key) => {
      this.allowedPrivileges[Privileges[key]] = true;
    });
  }

  /**
   * Flatten privileges from db and map it to
   * flat privilege object
   */
  private mapPrivilegesToAllowedMap(privileges) {
    privileges.map((privilege) => {
      this.allowedPrivileges[privilege.title] = privilege.permitted;
    });
  }

  /**
   * Flatten privileges from db and map it to
   * flat privilege object
   */
  private allowAllPermittedScreens() {
    // only adding root for now
    Object.keys(this.allowedPrivileges).forEach((privilegeKey) => {
      if (this.allowedPrivileges[privilegeKey] && PrivilegesRouteIdMap[privilegeKey] && PrivilegesRouteIdMap[privilegeKey].ROOT) {
        this.currentACLConfig.admin.allowedScreens.push(PrivilegesRouteIdMap[privilegeKey].ROOT);
        this.currentACLConfig.serviceWriter.allowedScreens.push(PrivilegesRouteIdMap[privilegeKey].ROOT);
      }
    });
  }

  /**
   * Run a step by step process to build acl component
   */
  buildACL(privileges): void {
    // reset current ACL configuration
    this.currentACLConfig = this.helperService.deepCopy(this.defaultACLConfig);
    this.constructAllowedPrivilegeMap();
    this.mapPrivilegesToAllowedMap(privileges);
    this.allowAllPermittedScreens();
  }

  /**
   * Get Dashboard entry point
   * @param  {string} role
   * @returns {string} screen name
   */
  getEntry(role) {
    let entryRoute: string = this.currentACLConfig[role].entry || '';
    if (role === 'admin' || role === 'serviceWriter') {
      // git first route that matches
      entryRoute =
        Object.keys(this.allowedPrivileges).reduce((routeSoFar, currentPrivilege) => {
          return routeSoFar || (this.allowedPrivileges[currentPrivilege] && PrivilegesEntryRouteMAP[currentPrivilege]);
        }, '') || entryRoute;
    }

    return entryRoute;
  }

  /**
   *  Get Navigation Menu
   *  @param  {string} role
   *  @returns {Array<object>} JOSN Object Array
   */
  getNav(role) {
    return this.currentACLConfig[role].nav;
  }

  /**
   *  Get Allowed Privileges
   *
   *  @returns {Array<object>} JOSN Object Array
   */
  getAllowedPrivileges() {
    return this.allowedPrivileges;
  }

  /**
   * Page Access Permission
   * @param  {string} url Screen URL
   * @param  {string} role User Role
   * @returns {boolean} User Screen Permission
   */
  pageAccessPermission(data: any, role: string, isWorkAsTechEnabled: boolean = false) {
    if (['admin', 'serviceWriter'].includes(role) && isWorkAsTechEnabled) {
      return this.currentACLConfig[role].allowedScreens.includes(data.id) || this.currentACLConfig['tech'].allowedScreens.includes(data.id);
    } else {
      return this.currentACLConfig[role].allowedScreens.includes(data.id);
    }
  }
}
